import WRAP from "WRAP-JS";
import { configLonLatLayer } from "./config/ConfigLonLat";
import { MAP_ID_LONLAT } from "../../../store/MapContentsState";

class LonLat {
  static NAME = MAP_ID_LONLAT;
  layer;
  firstDraw = true;
  constructor() {
    this.layer = new WRAP.Geo.Layer(LonLat.NAME);
    this.layer.setVisible(false);
    this.layer.disableInteraction(true);
    this.layer.setStyle('Mercator');
  }

  drawLayer(visible) {
    if (this.firstDraw) {
      this.layer.configure(null, configLonLatLayer);
      this.firstDraw = false;
    }
    this.setVisible(visible);
  }

  changeProjection() {
    this.layer.setStyle(this.layer.view.projection.name);
    if (this.layer._renderer) {
      this.layer._renderer.labels = undefined//WRAP側で設定がキャッシュされてしまっているので削除
    }
    WRAP.Geo.invalidate();
  }

  updateBounds() {
    if (this.layer.visible()) {
      this.layer.invalidate();
    }
  }

  getLayer() {
    return this.layer;
  }

  setVisible(visible) {
    if (visible) {
      this.layer.show();
    } else {
      this.layer.hide();
    }
  }

}
export default LonLat;